import { createApp } from 'vue'
import ElementPlus from 'element-plus'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import 'element-plus/dist/index.css'
import locale from 'element-plus/dist/locale/zh-tw.mjs'
import i18n from 'i18n-plugin'
import router from '@/router'
import App from './App.vue'

i18n.global.warnHtmlInMessage = 'off'

const app = createApp(App)

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

app.use(i18n)
app.use(router)
app.use(ElementPlus, { locale })
app.mount('#app')
